import { useEffect, useState } from 'react';
import Get from '../api/internal/Get';

export type ChartOfAccountType =
  | 'expense'
  | 'revenue'
  | 'asset'
  | 'liability'
  | 'equity';

export type AccountDetailType =
  | 'Accounts Payable (A/P)'
  | 'Accounts Receivable (A/R)'
  | 'Checking'
  | 'Money Market'
  | 'Cost of labor - COS'
  | 'Other Costs of Services - COS'
  | 'Shipping, Freight & Delivery - COS'
  | 'Credit Card'
  | 'Common Stock'
  | "Owner's Equity"
  | 'Retained Earnings'
  | 'Partner Distributions'
  | 'Charitable Contributions'
  | 'Advertising/Promotional'
  | 'Other Business Expenses'
  | 'Tax expense'
  | 'Office/General Administrative Expenses'
  | 'Supplies & Materials'
  | 'Rent or Lease of Buildings'
  | 'Dues & subscriptions'
  | 'Cost of Labor'
  | 'Taxes Paid'
  | 'Accumulated Amortization'
  | 'Accumulated Depreciation'
  | 'Fixed Asset Computers'
  | 'Machinery & Equipment'
  | 'Vehicles'
  | 'Intangible Assets'
  | 'Sales of Product Income'
  | 'Discounts/Refunds Given'
  | 'Service/Fee Income'
  | 'Notes Payable'
  | 'Other Long Term Liabilities'
  | 'Other Long-term Assets'
  | 'Other Current Assets'
  | 'Inventory'
  | 'Prepaid Expenses'
  | 'Undeposited Funds'
  | 'Payroll Clearing'
  | 'Other Current Liabilities'
  | 'Insurance Payable'
  | 'Line of Credit'
  | 'Loan Payable'
  | 'Dividend Income'
  | 'Other Miscellaneous Income'
  | 'Interest Earned';

type UseChartOfAccountTypeOptionsParams = {
  accountType?: ChartOfAccountType | ChartOfAccountType[];
  accountDetailType?: AccountDetailType | AccountDetailType[];
};

function useChartOfAccountTypeOptions({
  accountType,
  accountDetailType,
}: UseChartOfAccountTypeOptionsParams) {
  const [chartOfAccountOptions, setChartOfAccountOptions] = useState<
    ChartOfAccount[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);

    const queryParams = new URLSearchParams();

    if (accountType) {
      const accountTypes = Array.isArray(accountType)
        ? accountType
        : [accountType];
      accountTypes.forEach(type => queryParams.append('accountType', type));
    }

    if (accountDetailType) {
      const accountDetailTypes = Array.isArray(accountDetailType)
        ? accountDetailType
        : [accountDetailType];
      accountDetailTypes.forEach(type =>
        queryParams.append('accountDetailType', type),
      );
    }

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `/Accounting/GetChartOfAccountsList?${queryString}`
      : '/Accounting/GetChartOfAccountsList';

    Get(endpoint)
      .then(response => {
        if (response) {
          setChartOfAccountOptions(response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [accountType, accountDetailType]);

  return { chartOfAccountOptions, loading };
}

export default useChartOfAccountTypeOptions;
